export function validateTrafficCertificates(primaryNumber, primaryClasses = [], certificates = []) {
 if (!Array.isArray(certificates) || certificates.length > 2) throw new Error('A maximum of 3 traffic certificates is allowed.');
 const classes = /^SOC/i.test(String(primaryNumber || '').trim()) ? [...primaryClasses] : [];
 if (classes.length > 1) throw new Error('Select one class per certificate.');
 const allowed = ['Traffic Controller', 'Implement Traffic Control Plans', 'Prepare A Work Zone Traffic Management Plan'];
 const ids = new Set();
 for (const item of certificates) {
  if (!item || !item.id || ids.has(item.id)) throw new Error('Invalid certificate record.');
  ids.add(item.id);
  if (item.class && !allowed.includes(item.class)) throw new Error('Select a valid certificate class.');
  if (item.number && !/^SOC[0-9]*$/i.test(item.number)) throw new Error('Certificate numbers must start with SOC followed by numbers.');
  if (item.date && !Number.isFinite(new Date(item.date).getTime())) throw new Error('Select a valid certificate date.');
  if (item.class) classes.push(item.class);
 }
 if (new Set(classes).size !== classes.length) throw new Error('Each traffic certificate must have a different class.');
}
